import React, {ReactElement} from 'react';
import {toString} from 'ui/keyboard';
import {useDispatch} from 'ui/store';
import {useUIStore, showKeyboard, hideKeyboard} from 'store/UI';
import {useKeyboard} from 'store/UserInput';

import {blurActiveElement as closeDateSelect} from 'ui/effects/blurActiveElement';
import {PressEventProvider, PressEventProps} from 'components/PressEventProvider';
import {DynamicFontSize} from 'components/DynamicFontSize';
import {Animate} from 'components/Animate';
import {Shout} from 'components/Text';
import {Control, Prefix, Row, Overlay} from '../style';

export const Amount = (): ReactElement => {
  const keyboard = useKeyboard();
  const {keyboardVisible} = useUIStore();

  const dispatchShowKeyboard = useDispatch(showKeyboard);
  const dispatchHideKeyboard = useDispatch(hideKeyboard);

  const onFocus = (): void => {
    closeDateSelect();
    dispatchShowKeyboard();
  };

  return (
    <Row>
      <Prefix>Сумма</Prefix>
      <Control>
        <PressEventProvider onPress={onFocus}>
          {(props: PressEventProps) => (
            <Shout className='display' {...props}>
              <DynamicFontSize>
                <span data-test='remainder'>{toString(keyboard)}</span>
              </DynamicFontSize>
            </Shout>
          )}
        </PressEventProvider>

        <Animate mount={keyboardVisible}>
          <PressEventProvider onPress={dispatchHideKeyboard}>
            {(props: PressEventProps) => <Overlay data-test='overlay' {...props} />}
          </PressEventProvider>
        </Animate>
      </Control>
    </Row>
  );
};
